import { useBemCN } from '@gik/core/utils/bemBlock';
import type React from 'react';

const blockName = 'saved-items-empty';

export function SavedItemsEmpty({
  children,
  small,
}: React.PropsWithChildren<{
  small?: boolean;
}>) {
  const bem = useBemCN(blockName);

  return (
    <div {...bem(null, [{ small: small }])}>
      <div {...bem('preview')}>
        <span {...bem('instructions')}>{children}</span>
      </div>
    </div>
  );
}
